"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.oneTimeSubscription = exports.Event = void 0;
const arrays_1 = require("../async/arrays");
const logger_1 = require("../logger");
class Event {
    constructor(withDefaultLogger = true) {
        this._handlers = [];
        this._logger = null;
        if (withDefaultLogger) {
            this.withLogger();
        }
    }
    withLogger(loggerOrName) {
        this._logger = (!loggerOrName || typeof loggerOrName === 'string')
            ? (0, logger_1.createLogger)(`[Event:${loggerOrName || '?'}]`)
            : loggerOrName;
        return this;
    }
    on(handler) {
        this._handlers.push(handler);
        return () => {
            this.off(handler);
        };
    }
    off(handler) {
        this._handlers = this._handlers.filter(h => h !== handler);
    }
    trigger(data) {
        if (!this._handlers.length) {
            return;
        }
        const hh = this._handlers.slice(0);
        hh.forEach(cb => {
            try {
                cb(data);
            }
            catch (err) {
                this.logError(data, cb, err);
            }
        });
    }
    async triggerAsync(data) {
        if (!this._handlers.length) {
            return [];
        }
        const hh = this._handlers.slice(0);
        const errors = [];
        await (0, arrays_1.forEachAsync)(hh, async (cb) => {
            try {
                await cb(data);
            }
            catch (err) {
                this.logError(data, cb, err);
                errors.push(err);
            }
        });
        return errors;
    }
    expose() {
        return this;
    }
    logError(data, cb, err) {
        var _a;
        (_a = this._logger) === null || _a === void 0 ? void 0 : _a.error(`[Event.${typeof data}] Handler ${cb.name} thrown an exception: `, err);
    }
}
exports.Event = Event;
function oneTimeSubscription(e, filter) {
    return new Promise((resolve) => {
        let unsubscribe = null;
        unsubscribe = e.on(v => {
            if (!filter || filter(v)) {
                // the callback can be called during subscription, so unsubscribe may not be initialized yet.
                // in that case assume that unsubscribing is not needed
                unsubscribe === null || unsubscribe === void 0 ? void 0 : unsubscribe();
                resolve(v);
            }
        });
    });
}
exports.oneTimeSubscription = oneTimeSubscription;
//# sourceMappingURL=event.js.map